import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Container from '@mui/material/Container';
import './ReferAdviser.scss';
import { withRouter } from 'react-router';
import ShareButtonGroup from '../../components/ShareButtonGroup/ShareButtonGroup';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from 'tss-react/mui';
import { getUserMissions } from '../../store/userMission/duck';
import { Box, Collapse, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { tracking } from '../../utils/tracking';

const useStyles = makeStyles()(theme => ({
  headerTitle: { fontWeight: 'bold', marginBottom: theme.spacing(1), textAlign: 'left' },
  headerSubtitle: { marginBottom: theme.spacing(2), textAlign: 'left' },
  sectionTitle: { fontWeight: 'bold', marginTop: theme.spacing(3), marginBottom: theme.spacing(1), textAlign: 'left' },
  rewardCard: { marginTop: theme.spacing(2), marginBottom: theme.spacing(3) },
  rewardItem: { marginBottom: theme.spacing(1), paddingLeft: theme.spacing(2), textAlign: 'left' },
  stepTitle: { fontWeight: 'bold', marginTop: theme.spacing(2), marginBottom: theme.spacing(1), textAlign: 'left' },
  stepContent: { marginBottom: theme.spacing(1), textAlign: 'left' },
  brandAmbassadorTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    textAlign: 'left'
  },
  brandAmbassadorBenefit: { marginBottom: theme.spacing(1), textAlign: 'left' },
  termsTitle: { fontWeight: 'bold', marginTop: theme.spacing(3), marginBottom: theme.spacing(2), textAlign: 'left' },
  termsSection: { marginBottom: theme.spacing(2), textAlign: 'left', fontSize: 'small' },
  termsSectionTitle: { fontWeight: 'bold', marginBottom: theme.spacing(1), textAlign: 'left', fontSize: 'small' },
  termsBullet: { marginLeft: theme.spacing(2), marginBottom: theme.spacing(1), textAlign: 'left', fontSize: 'small' },
  finalNote: {
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    textAlign: 'left'
  }
}));

const ReferAdviser = props => {
  const { classes } = useStyles();
  const { intl, userDetails, userMissions, getUserMissions } = props;

  const [ambassadorOpen, setAmbassadorOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  const referAdviserMsg = intl.formatMessage({ id: 'refer-adviser-msg' });
  const searchStr = new URLSearchParams({
    campaignCode: userDetails.email,
    planMode: 'ref'
  }).toString();
  const referAdviserLink = `${process.env.PFPLUS_URL}/signup?${searchStr}`;

  const { gainedRewards, variables } =
    (userMissions || []).find(userMission => userMission.missionListId.id === 'adviser-referral') || {};
  const { referAdviserRegister, referAdviserSubscribe } = variables || {};
  const { bonusDay } = (gainedRewards || []).reduce(
    (acc, reward) => {
      if (reward.type === 'extend-current-subscription') {
        acc.bonusDay += reward.quantity;
      }
      return acc;
    },
    { bonusDay: 0 }
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getUserMissions();
  }, [getUserMissions]);

  const individualRewards = [
    { text: '1 - 4人：💵 $200 Coupon' },
    { text: '朋友優惠：年費 $6,888 → $4,788' },
    { text: '5人：⌚ Apple Watch（價值 $1,999）' },
    { text: '朋友優惠：年費 $6,888 → $4,788' },
    { text: '10人：📱 iPad（價值 $2,799）' },
    { text: '朋友優惠：年費 $6,888 → $4,788' }
  ];

  const teamRewards = [
    { text: '>20人：💰 $1,500 現金獎' },
    { text: '>35人：💰 $3,000 現金獎' },
    { text: '>50人：💰 $5,000 現金獎' }
  ];

  return (
    <div className="refer-adviser">
      <Container className="container" maxWidth="sm">
        <img src="img/referral_program.jpeg" alt="referral-program" style={{ width: 'inherit' }} />

        <Card className={classes.rewardCard}>
          <CardContent>
            <Typography className={classes.headerTitle}>
              🎁 推薦朋友用 PORTFO+，你有機會拎走 Apple Watch / iPad！
            </Typography>
            <Typography className={classes.headerSubtitle}>
              💙 被推薦人即享 <span className={classes.headerTitle}>年費減 $2,100</span> 優惠！
            </Typography>
            <Typography className={classes.headerTitle}>數碼轉型，讓你的客戶感受更專業、更安心。</Typography>

            <ShareButtonGroup
              title={referAdviserMsg}
              url={referAdviserLink}
              isCTA
              CopyTextFieldProps={{ multiline: true }}
              onShare={() => {
                tracking('Click on Refer Link - Native share');
              }}
              onWhatsapp={() => {
                tracking('Click on Refer Link - Whatsapp Share');
              }}
              onWeChat={() => {
                tracking('Click on Refer Link - WeChat Share');
              }}
              onCopy={() => {
                tracking('Click on Refer Link - Copy');
              }}
            />

            <Typography className={classes.sectionTitle}>🎁 獎賞一覽表</Typography>
            <Typography className={classes.sectionTitle}>👤 個人推薦獎賞：</Typography>
            {individualRewards.map((reward, index) => (
              <Typography key={index} className={classes.rewardItem}>
                {reward.text}
              </Typography>
            ))}

            <Typography className={classes.sectionTitle}>👥 團隊分享邀請獎賞：</Typography>
            <Typography className={classes.rewardItem}>實際出席人數 | 獎賞</Typography>
            {teamRewards.map((reward, index) => (
              <Typography key={index} className={classes.rewardItem}>
                {reward.text}
              </Typography>
            ))}

            <Typography className={classes.stepTitle}>🔗 推薦教學（簡短說明）</Typography>
            <Typography className={classes.stepContent}>① 分享你的專屬邀請連結</Typography>
            <Typography className={classes.stepContent}>
              ② 朋友用連結訂閱 → 即享年費 $4,788 優惠（原價 $6,888）
            </Typography>
            <Typography className={classes.stepContent}>
              ③ 自動獲得獎賞（系統與客服會通知及跟進你的獎賞項目）
            </Typography>

            <Typography
              className={classes.brandAmbassadorTitle}
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              💼 FinTech 專業夥伴
            </Typography>
            <Typography className={classes.stepContent}>
              推薦超過 3位，即可成為「FinTech 專業夥伴」，享有以下專屬特權：
            </Typography>
            <Typography className={classes.brandAmbassadorBenefit}>
              ✨ 「FinTech 專業夥伴」推廣貼圖（可放 IG / FB）
            </Typography>
            <Typography className={classes.brandAmbassadorBenefit}>📢 PORTFO+ 官方IG 廣告曝光機會</Typography>
            <Typography className={classes.brandAmbassadorBenefit}>🖥️ PORTFO+ 網頁名人堂</Typography>

            {/* Collapsible: T&C */}
            <Typography
              className={classes.termsTitle}
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => setTermsOpen(!termsOpen)}
            >
              📌 條款及細則（T&C）
              <IconButton size="small">{termsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
            </Typography>
            <Collapse
              in={termsOpen}
              onEnter={() => {
                tracking('Click on Refer Page - T&C');
              }}
            >
              <Typography className={classes.stepContent}>PORTFO+ 推薦計劃｜Referral Program</Typography>

              {[
                {
                  title: '1. 推薦資格',
                  bullets: [
                    '• 所有已訂閱PORTFO+年費計劃之用戶均可參與推薦計劃。',
                    '• 每位用戶均可獲得一條專屬邀請連結，以追蹤推薦成效。'
                  ]
                },
                {
                  title: '2. 獎賞計算方式',
                  bullets: [
                    '• 個人推薦獎賞為累積計算，即推薦5位朋友，可同時獲得 $200 Coupon × 4 + Apple Watch（非二選一）。',
                    '• 團隊邀請獎賞以實際出席人數計算，並不可與個人推薦獎賞重複領取。'
                  ]
                },
                {
                  title: '3. 推薦人定義',
                  bullets: [
                    '• 被推薦者必須透過推薦連結成功訂閱並完成付款，方可計算為有效推薦。',
                    '• 若同一位被推薦人由多位用戶推薦，系統將以最先點擊連結者為準。'
                  ]
                },
                {
                  title: '4. 被推薦人優惠',
                  bullets: [
                    '• 所有透過推薦連結訂閱之新用戶，均可享有年費優惠價：$4,788（原價 $6,888）。',
                    '• 優惠只適用於首次訂閱，不可與其他優惠碼同時使用。'
                  ]
                },
                {
                  title: '6. 獎賞派發時間與方式',
                  bullets: [
                    '• 所有獎賞將於推薦成功後 30日內派發，並由客服團隊主動聯絡安排。',
                    '• Apple Watch / iPad 將以實物或等值禮券形式派發（視乎庫存安排）。',
                    '• 現金獎將以轉數快或銀行轉帳方式處理。'
                  ]
                },
                {
                  title: '7. 其他條款',
                  bullets: [
                    '• PORTFO+ 保留審核推薦記錄之權利，如發現有任何濫用、造假、或違反公平原則之行為，有權取消其獎賞資格。',
                    '• 本活動如有任何更改，恕不另行通知，PORTFO+ 保留最終解釋及修訂權利。'
                  ]
                }
              ].map((section, idx) => (
                <div key={idx} className={classes.termsSection}>
                  <Typography className={classes.termsSectionTitle}>{section.title}</Typography>
                  {section.bullets.map((b, i) => (
                    <Typography key={i} className={classes.termsBullet}>
                      {b}
                    </Typography>
                  ))}
                </div>
              ))}

              <Box className={classes.finalNote}>
                <Typography variant="body2">
                  🔍 所有推薦記錄及獎賞派發，將由PORTFO+系統自動追蹤並由客服聯絡你～唔使自己計數，專心出單就得啦！😊
                </Typography>
              </Box>
            </Collapse>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    userMissions: state.userMission.userMissions ? [...state.userMission.userMissions] : undefined
  }),
  { getUserMissions }
)(ReferAdviser);

export default injectIntl(withRouter(container));
